<template>
  <hel-module title="经营报表" :class="scope.clsPrefix">
    <div class="business-report-list">
      <a
        v-for="item in reportList"
        :key="item.key"
        class="business-report-link"
        href="javascript:void(0)"
        @click.prevent="handleOpenReport(item)"
      >{{ item.label }}</a>
    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'

const REPORTS = [
  { key: 'order-forecast-revenue', label: '卡奥斯在手订单全年预测 — 收入', url: 'ceo-order-forecast-report.html?type=revenue' },
  { key: 'order-forecast-profit', label: '卡奥斯在手订单全年预测 — 利润', url: 'ceo-order-forecast-report.html?type=profit' },
  { key: 'industry-operation', label: '五大行业经营情况', url: 'ceo-industry-operation-report.html' },
  { key: 'chain-operation', label: '业务链群经营情况', url: 'ceo-chain-operation-report.html' },
  { key: 'customer-structure', label: '客户结构经营情况', url: 'ceo-customer-structure-report.html' },
  { key: 'overseas-chain-revenue', label: '卡奥斯海外链群收入', url: 'ceo-overseas-chain-revenue-report.html' }
]

export default {
  name: 'OperatingReport',
  components: {
    HelModule
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-operating-report'
      },
      reportList: REPORTS
    }
  },
  methods: {
    handleOpenReport(report) {
      this.$emit('open-tool', { id: report.key, title: report.label })
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: 'rvc-cosmoplat-workspace-operating-report';

.#{$class-prefix} {
  .business-report-list {
    display: flex;
    flex-direction: column;
    gap: 7px;
    height: 100%;
    justify-content: flex-start;
  }

  .business-report-link {
    display: block;
    width: 100%;
    padding: 9px 11px;
    border-radius: 10px;
    border: 1px solid rgba(74, 95, 243, .13);
    background: linear-gradient(135deg, rgba(74, 95, 243, .055), rgba(45, 127, 249, .025));
    color: #30425f;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.35;
    text-decoration: none;
    box-sizing: border-box;
    transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease, color .2s ease;
    cursor: pointer;

    &:hover {
      transform: translateX(3px);
      border-color: rgba(74, 95, 243, .3);
      box-shadow: 0 9px 20px rgba(74, 95, 243, .1);
      color: #2d7ff9;
    }
  }
}
</style>
